import { render } from "./EventInfo.vue?vue&type=template&id=6cd79cd9&ts=true"
import script from "./EventInfo.vue?vue&type=script&lang=ts"
export * from "./EventInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__